import { GET_METRICAS_RECUPERO } from '../types';

export default function dashboardRecuperoReducer(state = {}, action) {
    switch (action.type) {
        case GET_METRICAS_RECUPERO:
            return action.error ? { ...state, metricas: null } : { ...state, metricas: action.payload }
        default:
            return state
    }
}
